/**
 * Cotizaciones semilla para el mockup (solo datos de prueba).
 */
export const SEED_QUOTES = [
	{
		id: "seed-quote-1",
		number: "COT-DN-2026-0001",
		status: "emitida",
		issuerCompanyId: "empresa-afecta",
		issuerSnapshot: {
			nombreLegal: "DeNegocios Servicios Empresariales SpA",
			nombreFantasia: "DeNegocios.cl",
			rut: "76.123.456-7",
			telefono: "+56 9 1234 5678",
			correo: "contacto@denegocios.cl",
			direccion: "Av. Providencia 1234, Santiago, Chile",
			logo: "DN",
			logoColor: "#1a365d",
			tipoTributario: "afecta",
			tasaIva: 19,
			prefijoNumero: "DN",
		},
		sellerId: "seed-vendedor-1",
		sellerSnapshot: {
			nombre: "Vendedor Demo",
			correo: "vendedor@denegocios.cl",
			telefono: "+56 9 1111 1111",
			rol: "Vendedor",
		},
		client: {
			rut: "76.543.210-K",
			nombre: "Comercial Andes Sur SpA",
			correo: "contacto@andessur.cl",
			telefono: "+56 2 2345 6789",
			giro: "Comercio al por mayor",
			domicilio: "Calle Los Álamos 450",
			comuna: "Providencia",
		},
		items: [
			{
				id: "seed-item-1",
				productId: "crear-spa",
				nombre: "Constitución de sociedad SpA",
				descripcion: "Constitución de empresa mediante el sistema Empresa en un Día.",
				cantidad: 1,
				precioUnitario: 100000,
				tipoDescuento: "none",
				valorDescuento: 0,
				montoDescuento: 0,
				subtotal: 100000,
				total: 100000,
			},
			{
				id: "seed-item-2",
				productId: "direccion",
				nombre: "Dirección tributaria",
				descripcion: "Servicio de dirección tributaria por doce meses.",
				cantidad: 1,
				precioUnitario: 150000,
				tipoDescuento: "percent",
				valorDescuento: 10,
				montoDescuento: 15000,
				subtotal: 150000,
				total: 135000,
			},
		],
		globalDiscount: { type: "none", value: 0, amount: 0 },
		subtotal: 250000,
		lineDiscountsTotal: 15000,
		netTotal: 235000,
		taxRate: 19,
		taxTotal: 44650,
		grandTotal: 279650,
		paymentMethod: "Transferencia bancaria",
		customPaymentMethod: "",
		validityDays: 15,
		customValidityDays: "",
		executionTime: "Entre 3 y 5 días hábiles desde la recepción de los antecedentes.",
		conditions:
			"La prestación del servicio comenzará una vez confirmado el pago y recibidos todos los antecedentes necesarios.",
		notes: "Cotización de ejemplo (afecta a IVA).",
		createdAt: "2026-07-01T10:00:00.000Z",
		updatedAt: "2026-07-01T10:30:00.000Z",
		issuedAt: "2026-07-01T10:30:00.000Z",
	},
	{
		id: "seed-quote-2",
		number: null,
		status: "borrador",
		issuerCompanyId: "empresa-exenta",
		issuerSnapshot: {
			nombreLegal: "Asesorías Profesionales DeNegocios Ltda.",
			nombreFantasia: "DeNegocios Asesorías",
			rut: "77.987.654-3",
			telefono: "+56 9 8765 4321",
			correo: "asesorias@denegocios.cl",
			direccion: "Av. Apoquindo 4500, Las Condes, Santiago, Chile",
			logo: "AE",
			logoColor: "#276749",
			tipoTributario: "exenta",
			tasaIva: 0,
			prefijoNumero: "AE",
		},
		sellerId: "seed-vendedor-2",
		sellerSnapshot: {
			nombre: "Asesor Demo",
			correo: "asesor@denegocios.cl",
			telefono: "+56 9 2222 2222",
			rol: "Contabilidad",
		},
		client: {
			rut: "12.345.678-5",
			nombre: "María Pérez Consultores",
			correo: "maria@ejemplo.cl",
			telefono: "+56 9 5555 5555",
			giro: "Asesorías profesionales",
			domicilio: "Pasaje El Sol 12",
			comuna: "Ñuñoa",
		},
		items: [
			{
				id: "seed-item-3",
				productId: "contabilidad",
				nombre: "Servicio de contabilidad mensual",
				descripcion: "Servicio mensual de contabilidad para pequeñas empresas.",
				cantidad: 3,
				precioUnitario: 80000,
				tipoDescuento: "fixed",
				valorDescuento: 20000,
				montoDescuento: 20000,
				subtotal: 240000,
				total: 220000,
			},
		],
		globalDiscount: { type: "fixed", value: 10000, amount: 10000 },
		subtotal: 240000,
		lineDiscountsTotal: 20000,
		netTotal: 210000,
		taxRate: 0,
		taxTotal: 0,
		grandTotal: 210000,
		paymentMethod: "Pago en línea",
		customPaymentMethod: "",
		validityDays: 30,
		customValidityDays: "",
		executionTime: "Inicio inmediato tras confirmación.",
		conditions:
			"La prestación del servicio comenzará una vez confirmado el pago y recibidos todos los antecedentes necesarios.",
		notes: "Borrador de ejemplo (empresa exenta).",
		createdAt: "2026-07-10T15:00:00.000Z",
		updatedAt: "2026-07-10T15:00:00.000Z",
		issuedAt: null,
	},
];
